var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import Size from '../../private/enums/Size';
import Container from '../styles/Container';
import Inner from '../styles/Inner';
import Label from '../styles/Label';
import LabelInner from '../styles/LabelInner';
import ShowPassword from '../styles/ShowPassword';
import HintText from './HintText';
import Input from './Input';
const TextInputPassword = forwardRef((props, ref) => {
    const { id, inputSize = Size.MEDIUM, type, disabled, placeholder = ' ', label, hintText, isError, dir, showPasswordText, isSharpLeftSide, isSharpRightSide, isSharpTopSide, isSharpBottomSide, isTopBottomBorderHidden, isSideBorderHidden, backgroundColor = 'gohan' } = props, rest = __rest(props, ["id", "inputSize", "type", "disabled", "placeholder", "label", "hintText", "isError", "dir", "showPasswordText", "isSharpLeftSide", "isSharpRightSide", "isSharpTopSide", "isSharpBottomSide", "isTopBottomBorderHidden", "isSideBorderHidden", "backgroundColor"]);
    const [passwordShown, setPasswordShown] = React.useState(false);
    const togglePasswordVisiblity = () => {
        setPasswordShown(passwordShown ? false : true);
    };
    const inputProps = Object.assign({ placeholder,
        dir,
        isTopBottomBorderHidden,
        isSideBorderHidden }, rest);
    const containerProps = {
        disabled,
        isSharpLeftSide,
        isSharpRightSide,
        isSharpTopSide,
        isSharpBottomSide,
    };
    if (inputSize === Size.XLARGE) {
        return (React.createElement(Container, Object.assign({}, containerProps),
            React.createElement(Inner, { bgColor: backgroundColor },
                React.createElement(Input, Object.assign({ inputSize: inputSize, type: passwordShown ? 'text' : 'password', error: isError, ref: ref, id: id, isLabel: !!label, isPassword: true }, inputProps, containerProps)),
                React.createElement(LabelInner, { isRtl: dir === 'rtl' }, label),
                React.createElement(ShowPassword, { onClick: togglePasswordVisiblity, isRtl: dir === 'rtl' }, showPasswordText)),
            hintText && React.createElement(HintText, { isError: isError }, hintText)));
    }
    return (React.createElement(Container, Object.assign({}, containerProps),
        label && (React.createElement(Label, { dir: dir, htmlFor: id }, label)),
        React.createElement(Inner, null,
            React.createElement(Input, Object.assign({ inputSize: inputSize, type: passwordShown ? 'text' : 'password', error: isError, ref: ref, id: id, isPassword: true, bgColor: backgroundColor }, inputProps, containerProps)),
            React.createElement(ShowPassword, { onClick: togglePasswordVisiblity, isRtl: dir === 'rtl' }, showPasswordText)),
        hintText && React.createElement(HintText, { isError: isError }, hintText)));
});
export default TextInputPassword;
